(function ($) {
  /**Menu**/
  function customSubMenu(){
    $( ".nav-dropdown.nav-dropdown--first" ).each(function( index ) {

      if(!$(this).find(".nav-dropdown--second").length){
        $(this).parent().addClass("not-dropdown-second");
      }
    });

  }

  customSubMenu();

  /**Search page**/
  $('.search__form .input-group__submit').on('click', function(){
    var input_search = $(".search__form .form__input").val().replace("/", " ");
    $(".search__form .form__input").val(input_search);
  });

  /**Tooltip**/
  $(".price-tooltip, .point-tooltip").mouseover(function(){
    if($(window).innerWidth() > 800){
      var scrollTop     = $(window).scrollTop(),
          elementOffset = $(this).offset().top,
          distance      = elementOffset - scrollTop,
          tooltip = $(this).next(),
          heightTooltip = tooltip.height(),
          heightWindow = $(window).innerHeight();

      tooltip.removeClass("move-to-top");
      tooltip.removeClass("move-to-bottom");

      if(distance + heightTooltip >= heightWindow ){
        var newPosition = 0;
        //update position tooltip
        tooltip.addClass("move-to-top");
      }
      else if(distance <= heightTooltip){
        tooltip.addClass("move-to-bottom");
      }
      else{
        tooltip.removeClass("new-position");
      }
    }
  });


  /**FOOTER**/
  $('.menu_links > h2').on('click', function(){
    var parent = $(this).parent(),
        windowWidth = window.innerWidth;

    if(windowWidth <= 800){
      parent.toggleClass("open");
    }

  });


  /**Home page**/

  /**New product**/
  var initNewProducts = function(domElement) {
    if (domElement.length === 0) {
      return;
    }

    domElement.slick({
      dots: false,
      //       dotsClass: 'slider-dots',
      arrows: true,
      adaptiveHeight: false,
      mobileFirst: true,
      infinite: false,
      centerMode: false,
      centerPadding: '0',
      slidesToShow: 2,
      slidesToScroll: 1,
      pauseOnHover: false,
      accessibility: false,
      useCSS: true,
      prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
      nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
      responsive: [

        {
            breakpoint: 320,
            settings: 'unslick'
          },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
          }
        }
      ]

    })
  };



  /**Promotion Products**/
  function initPromotion(domElement) {
    if (domElement) {
      const elms = domElement.find('.list-products');
      elms.each(function() {
        var elm = $(this);

        if (elm.hasClass('slick-initialized')) {
          elm.slick('unslick');
        }
      })
    }
  }

  /**Category Mobile**/
  var initCategoryMobile = function(domElement) {
    if (domElement.length === 0) {
      return;
    }

    domElement.slick({
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      mobileFirst: true,
      infinite: false,
      centerMode: false,
      centerPadding: '0',
      slidesToShow: 4,
      slidesToScroll: 4,
      pauseOnHover: false,
      accessibility: false,
      useCSS: true,
      prevArrow: '',
      nextArrow: '',
      responsive: [
        {
          breakpoint: 320,
          settings: {
            focusOnSelect: false,
            centerPadding: '5px',
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: false,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: '5px',
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: false,
            arrows: false
          }
        },
        {
          breakpoint: 1025,
          settings: 'unslick'
        }
      ]

    })
  };

  /**Recently Viewed Item**/
  var initRecentViewed = function(domElement) {
    if (domElement.length === 0) {
      return;
    }

    domElement.slick({
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      mobileFirst: true,
      infinite: false,
      centerMode: false,
      centerPadding: '0',
      slidesToShow: 2,
      slidesToScroll: 1,
      pauseOnHover: false,
      accessibility: false,
      useCSS: true,
      prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
      nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
      responsive: [

        {
            breakpoint: 320,
            settings: 'unslick'
          },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 6
          }
        }
      ]

    })
  };

  $(document).ready(function() {
    if($("body").hasClass("template-index")){
      initPromotion($('.shopify-section__promotions-product'));
      initNewProducts($('.section-new-products .list-products'));
    }

    if($("#recently-viewed-products").hasClass("slick-initialized")){
      $("#recently-viewed-products").slick("unslick");
    }
    initRecentViewed($('#recently-viewed-products'));

    setWidthCategoryMobile();

    $( window ).resize(function() {
      setWidthCategoryMobile();
    });

    $(".fs-slideshow__slide.slick-slide").attr("data-current-time", $.now());

    $(".review-tab-title").on("click", function(){
      const detail = {
        type: 'reviewsClick',
        label: ''
      }
      dispatchEvent(detail);

//       showReview();
    });

    moveReviewToTabs();

    setTimeout(function(){
//       moveReviewToTabs();

      hideNoRating();
    }, 3000);

    // Replace color when th language
    function setColorSwatch(){
      window.colors = {
        สีขาว: "White",
        สีเขียว: "Green",
        สีฟ้า: "Blue",
        สีทอง: "Gold",
        สีแดง: "Red",
        สีชมพู: "Pink",
        สีเงิน: "Silver",
        เงิน: "Silver",
        สีเหลือง: "Yellow",
        สีชมพูอ่อน: "Light Pink",
        สีน้ำตาล: "Brown",
        สีเทา: "Gray",
        น้ำตาลอ่อน: "Light Brown",
        สีครีม: "Cream",
        สีม่วง: "Purple",
        สีดำ: "black",
        ดำ: "black",
        สีส้ม: "orange",
      }

      $.each($('.color-swatch'), function(i, ele){
        let styleAttr = $(ele).attr('style');
  
        styleAttr = styleAttr.split(':')[1].trim();
        styleAttr = styleAttr.replace(";",'');
        styleAttr = window.colors[styleAttr];

        $(ele).css('background-color', styleAttr);
      })
    };

    setColorSwatch();
  });

  var setWidthCategoryMobile = function(){
    var widthBrowser = $( window ).width();

    if(widthBrowser < 768){
      var categoryItem = $(".js-list-category-mobile .category-item");
      var withcategoryItem = categoryItem.width(widthBrowser*0.21);
      $(".shopify-section__category-list-mobile").css('display','block');
      $(".js-list-category-mobile").width(categoryItem.length*withcategoryItem);
    }else{
      $(".js-list-category-mobile").width('auto');
    }
  }

  /**Disable Scroll on mobile**/

  function disableScroll(){
    $('.header__nav-toggle').on('touchmove', function (evt) {
      evt.preventDefault();
    });
  }
  function enableScroll(){
    $('.header__nav-toggle').off('touchmove', function (evt) {
      evt.preventDefault();
    });
  }

  $('.header__nav-toggle').on('click', function (evt) {
    checkDevice();
  });

  function checkDevice(){
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    if(windowWidth <= 1024 && $('.sidebar-nav').hasClass('sidebar-nav--open')){
      disableScroll();
    }
    else {
      enableScroll();
    }
  }

  function closeMinicart() {
    if(headerSearch.hasClass('header-search--open')) {
      headerSearch.removeClass('header-search--open');
    }
    if(miniCart.hasClass('mini-cart--open')) {
      miniCart.removeClass('mini-cart--open');
    }
    if(userLink.hasClass('open')) {
      userLink.removeClass('open');
      navUser.hide();
    }

    $('.page__overlay').removeClass('page__overlay--open');

    $("body").removeClass('no-scroll');

  }

  $('.page__overlay').bind('touchstart', function(e){
    closeMinicart();
  });

  // AA tracking button for mini cart
  $(document).on("click", '.close-minicart', function(event) {
    const detail = {
      type: 'continueShopping',
      label: 'continueShopping'
    }
    dispatchEvent(detail);
    closeMinicart();
  }); 
  
  $(document).on("click", '.mini-cart__buttons .button--checkout', function (event) {
    const detail = {
      type: 'proceedCheckout',
      label: 'proceedCheckout'
    }
    dispatchEvent(detail);
  });

  $(window).resize(function() {
    // initNewProducts($('.section-new-products .list-products'));
    initRecentViewed($('#recently-viewed-products'));

    if($("body").hasClass("template-index")){
      initNewProducts($('.section-new-products .list-products'));
    }
    checkDevice();
    // showReview();
    moveReviewToTabs();
  });

  /**Nav User Drop Down in Header**/
  var userLink = $('.user__link');
  var userDropdown = userLink.find('.link');
  var navUser = userLink.find('.nav-dropdown');
  var miniCart = $(".mini-cart");
  var headerSearch = $(".header-search");


  $(document).click(function (e) {

    if (!e) e = window.event;

    if($(e.target).hasClass("nav-dropdown__link")){
      //sub menu
      window.location.href = $(e.target).attr("href");
    }
    else if( $(e.target).hasClass("user__link") ||  $(e.target).parents(".user__link").length
            || $(e.srcElement).parents(".user__link").length
            || $(e.srcElement).hasClass("user__link")  ){

      if(headerSearch.hasClass('header-search--open')) {
        headerSearch.removeClass('header-search--open');
      }

      if(miniCart.hasClass('mini-cart--open')) {
        miniCart.removeClass('mini-cart--open');
      }

      if(userLink.hasClass('open')) {
        userLink.removeClass('open');
        $("body").removeClass('no-scroll');
        navUser.hide();
        $('.page__overlay').removeClass('page__overlay--open');
      }
      else {
        userLink.addClass('open');
        $("body").addClass('no-scroll');
        navUser.show();
        $('.page__overlay').addClass('page__overlay--open');
      }
    }
    else if( $(e.target).hasClass("search-form") ||  $(e.target).parents(".search-form").length  ){

      if(miniCart.hasClass('mini-cart--open')) {
        miniCart.removeClass('mini-cart--open');
      }

      if(userLink.hasClass('open')) {
        userLink.removeClass('open');
        navUser.hide();

      }
    }
    else {
      if( $(e.target).hasClass("page__overlay")){
        if(headerSearch.hasClass('header-search--open')) {
          headerSearch.removeClass('header-search--open');
        }
        if(miniCart.hasClass('mini-cart--open')) {
          miniCart.removeClass('mini-cart--open');
        }
        if(userLink.hasClass('open')) {
          userLink.removeClass('open');
          navUser.hide();
        }
        $('.page__overlay').removeClass('page__overlay--open');
        $("body").removeClass('no-scroll');
      }

      else if( $(e.target).hasClass("mini-cart-menu") || $(e.target).parents(".mini-cart-menu").length){
        if(headerSearch.hasClass('header-search--open')) {
          headerSearch.removeClass('header-search--open');
        }
        if(userLink.hasClass('open')) {
          userLink.removeClass('open');
          navUser.hide();
        }
      }
    }

  });

  function phone_validate(phno) {
    var regexPattern=new RegExp(/^[0-9]+$/);    // regular expression pattern
    return regexPattern.test(phno);
  }

  // AA tracking
  /**Cart event for PDP & Collection page */
  async function fireCartEvent(type, skuProd, parentBtn) {
    var dataGWTProduct;

    try {
      dataGWTProduct = await getGWTdataProductDetail(`${skuProd}`);
    } catch (error) {
      dataGWTProduct = null;   
    }

    const dataDetail = {
      type: type,
      sku: skuProd,
      model: $(parentBtn.find(`input[name="model_"]`)).val(),
      superModel: $(parentBtn.find(`input[name="superModel_"]`)).val(),
      category: $(parentBtn.find(`input[name="sixdcode_"]`)).val(),
      gwCategory1: dataGWTProduct?.categories?.mainCategory?.[0] || '',
      gwCategory2: dataGWTProduct?.categories?.mainCategory?.[1] || '',
      gwCategory3: dataGWTProduct?.categories?.mainCategory?.[2] || '',
      gwSku: dataGWTProduct?.skuName || '',
      gwModel: dataGWTProduct?.modelName || '',
      gwSupermodel: dataGWTProduct?.superModelName || ''
    };

    var event = new CustomEvent("cartEvent", {
      detail: dataDetail
    });

    document.dispatchEvent(event);
  }

  function trackingCartEvent() {
    const btnTracking = $('.product__details .quantity-selector a, .product__details a.wishlist_collections');

    btnTracking.on('click', async function (e) {
      const dataType = $(this).attr('data-action');
      const parentBtn = $(this).parents(".product__details");
      let skuProd;
      let type;

      switch(dataType) {
        case 'decrease-product-quantity':
          skuProd = $(parentBtn.find('input[name^="sku"]')).val();
          type = 'unitChangeMinus';
          break;
        case 'increase-product-quantity':
          skuProd = $(parentBtn.find('input[name^="sku"]')).val();
          type = 'unitChangePlus';
          break;
        case 'wishlist':
          skuProd = $(this).attr('variant-sku');
          if ($(this).hasClass("wishlist_collections") && $(this).hasClass( "btn-active")) {
            type = 'favoriteRemove';
          } else {
            type = 'favoriteAdd';
          }
          break;
        }
        await fireCartEvent(type, skuProd, parentBtn);
    })

    const btnAddWishListPerItem = $('.product-item a.wishlist_collections');

    btnAddWishListPerItem.on('click', async function () {
      let type;
      const parentBtn = $(this).parents(".product-item__info");
      let skuProd = $(this).attr('variant-sku');

      if ($(this).hasClass("wishlist_collections") && $(this).hasClass( "btn-active")) {
        type = 'favoriteRemove';
      } else {
        type = 'favoriteAdd';
      }

      await fireCartEvent(type, skuProd, parentBtn);
    })
  }

  trackingCartEvent();

  $(".cart__items a.link").click(async function (e) {
    e.preventDefault();

    const dataType = $(this).data('type');
    let carData = [];
    $.ajax({
      method: 'GET',
      async: false,
      url: '/cart.js',
      dataType: 'json'
    }).done(function (cart) {
      if (cart) {
        carData = cart.items;
      }
    });

    let variantValue;
    let type;
    switch(dataType) {
      case 'reduce':
        variantValue = $($(this).parents().eq(2)).data("variant-id");
        type = 'unitChangeMinus';
        break;
      case 'increase':
        variantValue = $($(this).parents().eq(2)).data("variant-id");
        type = 'unitChangePlus';
        break;
      case 'wishlist':
        variantValue = $($(this).parents().eq(1)).data("variant-id");
        if ($(this).hasClass( "wishlist_collections") && $(this).hasClass( "btn-active")) {
          type = 'favoriteRemove';
        } else {
          type = 'favoriteAdd';
        }
        break;
      case 'delete':
          variantValue = $($(this).parents().eq(1)).data("variant-id");
          type = 'unitDelete';
        break;
    }
    
    const data = carData?.find(ele => ele.variant_id == variantValue);
    if (data) { 
      const skuProd = data.sku;
      var dataGWTProduct;

      try {
        dataGWTProduct = await getGWTdataProductDetail(`${skuProd}`);
      } catch (error) {
        dataGWTProduct = null;   
      }

      const dataDetail = {
        type: type,
        sku: skuProd,
        model: $(`input[name="model_${data.variant_id}"]`).val(),
        superModel: $(`input[name="superModel_${data.variant_id}"]`).val(),
        category: $(`input[name="sixdcode_${data.variant_id}"]`).val(),
        // category: data.product_type.toString()
        gwCategory1: dataGWTProduct?.categories?.mainCategory?.[0] || '',
        gwCategory2: dataGWTProduct?.categories?.mainCategory?.[1] || '',
        gwCategory3: dataGWTProduct?.categories?.mainCategory?.[2] || '',
        gwSku: dataGWTProduct?.skuName || '',
        gwModel: dataGWTProduct?.modelName || '',
        gwSupermodel: dataGWTProduct?.superModelName || ''
      };
      
      var event = new CustomEvent("cartEvent", {
        detail: dataDetail
      });
      document.dispatchEvent(event);
    }
    
    window.location.href = $(e.currentTarget).attr('href');
  });

  $(".header__logo-link, .header__main-nav a.link, .nav-dropdown__item a.nav-dropdown__link").click(function () {
    let detail = {};
    if ($(this).hasClass("header__logo-link")) {
      detail = {
        type: 'headerHome',
        label: ''
      };
    } else {
      const name = $(this).attr("data-title");
      detail = {
        type: 'headerCategory',
        label: name
      };
    }
    dispatchEvent(detail);
  });

  $(`.header__link.search-form a.link, .header__link.wishlist a.link, .header__link.mini-cart-menu a.link, 
    .header__link.user__link a.nav-dropdown__link.link`).click(function () {
    let detail;
    if ($(this).attr('aria-label') === 'Search') {
      detail = {
        type: 'headerSearch',
        label: ''
      };
    } else if ($(this).attr('href') === '/pages/wishlist') {
      detail = {
        type: 'headerWishlist',
        label: ''
      };
    } else if ($(this).attr('aria-label') === 'Cart') {
      detail = {
        type: 'headerCart',
        label: ''
      };
    } else if ($(this).attr('alt') === 'Sign In') {
      detail = {
        type: 'headerSignIn',
        label: ''
      };
    } else if ($(this).attr('alt') === 'Register') {
      detail = {
        type: 'headerRegister',
        label: ''
      };
    }

    if (detail) {
      dispatchEvent(detail);
    }
  });

  $(`.fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev[alt="Prev"], 
    .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next[alt="Next"]`).click(function () {
    let detail;
    const type = $(this).attr("alt");
    if (type === "Next") {
      detail = {
        type: 'sliderArrow',
        label: 'Next'
      };
    } else {
      detail = {
        type: 'sliderArrow',
        label: 'Previous'
      };
    }
    dispatchEvent(detail);
  });

  $('.product-item__see-more.button-wrapper, .product-item__title a[class="link"]').click(function () {
    let modelName;
    if ($(this).is('.product-item__see-more, .button-wrapper')) {
      modelName = $(this).parent().find('.product-item__info .product-item__title a[class="link"]').html();
    } else {
      modelName = $(this).html();
    }

    const detail = {
      type: 'viewDetail',
      label: modelName
    };
    dispatchEvent(detail);
  });

  $('.collection__filter.styled-select.collection-sort-by select').change(function () {
    const detail = {
      type: 'sortingClick',
      label: ''
    };
    dispatchEvent(detail);
  });

  $('.fs-slideshow__plyr-container').click(function() {
    const titleVideo = $(this).find('iframe').attr('title');
    const detail = {
      type: 'videoClick',
      label: titleVideo
    }
    dispatchEvent(detail);
  });

  $(`#shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev.slick-arrow, 
    #shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next.slick-arrow`).click(function () {
    let sliderArrow;
    const type = $(this).attr("title");
    if (type == "Prev") {
      sliderArrow = "Previous";
    } else {
      sliderArrow = "Next";
    }

    const detail = {
      type: 'sliderArrow',
      label: sliderArrow
    }
    dispatchEvent(detail);
  });

  $('.styled-select.styled-select--secondary select.single-option-selector').change(function () {
    const sizeSelect = $(this).val();
    const detail = {
      type: 'screenSize',
      label: sizeSelect
    }
    dispatchEvent(detail);
  });

  $('.product__slide-wrapper').click(function() {
    const detail = {
      type: 'carouselClick',
      label: ''
    }
    dispatchEvent(detail);
  });

  $('.quantity-selector a[data-action="increase-product-quantity"], .quantity-selector a[data-action="decrease-product-quantity"]').click(function () {
    let unitChange;
    var parent = $(this).parents('.product__details');
    if ($(this).attr('data-action') == 'increase-product-quantity') {
      unitChange = 'Plus';
    } else {
      unitChange = 'Minus';
    }

    const detail = {
      type: 'unitChange',
      label: unitChange,
      model: parent.find(`input[name^="model_"]`).val(),
      superModel: parent.find(`input[name^="superModel_"]`).val(),
      category: parent.find(`input[name^="sixdcode_"]`).val(),
    }
    dispatchEvent(detail);
  });

  $('.form__control.variant-colour .product__available-colors input[type="radio"]').change(function () {
    const color = $(this).val();
    const detail = {
      type: 'colorSwatch',
      label: color
    }
    dispatchEvent(detail);
  });

  $('body[class^="product"] li.tabs__nav-item').click(function () {
    const tabName = $(this).html().trim();
    //there was another event for Reviews
    if (tabName !== 'Reviews') {
      const detail = {
        type: 'stickynav',
        label: tabName
      };
      dispatchEvent(detail);
    }
  });

  $('.checkout-btn .button--continue-shoping').click(function () {
    const detail = {
      type: 'continueShopping',
      label: 'continueShopping'
    }
    dispatchEvent(detail);
  });

  function dispatchEvent(dataDetail) {
    // console.log('event', dataDetail);
    // debugger;
    var event = new CustomEvent("linkInteraction", {	
	    detail: dataDetail	
    });	

    document.dispatchEvent(event);	
  };
  // End AA Tracking 

  $(".main-menu__links > li").click(function(){
    setTimeout(function(){
      checkDevice();
    }, 500);
  });


  function loginWishlist(){
    if ($('.customer-logout-in').length > 0) {
      $('.wishlist-modal').click(function(e){
        var container = $(".wishlist-modal .content");

        if (!container.is(e.target) && container.has(e.target).length === 0){
          $('.wishlist-modal').removeClass('wishlist-popup-wrapper');
        }
      });

      $(".wishlist_login").on("click", function(e){
        e.preventDefault();
        $(".wishlist-modal").toggleClass('wishlist-popup-wrapper');

        $(".wishlist-modal .close-popup").on("click", function(){
          $(".wishlist-modal").removeClass('wishlist-popup-wrapper');
        });
      });
    }
  }

  function addWishlist(){
    if ($('.customer-logged-in').length > 0) {
      $(document).on('click', '.wishlist_collections:not(.btn-active)', function(e){
        e.preventDefault();

        const $this = $(this);
        $this.prop('disabled', true);

        const variantId = $this.attr('variantid');
        const productId = $this.attr('data-id');

        callAPIWithGWXToken('favorite/add', 'POST', [{
          "d2c_parent_id": productId,
          "d2c_id": variantId
        }]).then(() => {
          $this.addClass("btn-active");
          $this.find(".tooltip").text(window.languages.added);
          $this.prop('disabled', false);
        });
      });

      $( ".wishlist_collections" ).mouseover(function() {
        if($(this).hasClass("btn-active")){
          $(this).find(".tooltip").text(window.languages.removeWishlistText);
        } else{
          $(this).find(".tooltip").text(window.languages.addWishlistText);
        }
      });
    }
  }

  function removeWishlist(){
    if ($('.customer-logged-in').length > 0) {
      $(document).on('click', '.btn-active', function(e){
        e.preventDefault();

        const $this = $(this);
        $this.prop('disabled', true);
      
        const variantId = $this.attr('variantid');
        const productId = $this.attr('data-id');

        callAPIWithGWXToken('favorite/remove', 'DELETE', [{
          "d2c_parent_id": productId,
          "d2c_id": variantId
        }]).then(() => {   
          $this.removeClass("btn-active");
          $this.find(".tooltip").text(window.languages.removed);
          $this.prop('disabled', false);
        });
      });

      $(document).on('click', '.wishlist-content .grid__cell .btn-active', function(e){
        $(this).parents(".grid__cell").remove();
      });
    }
  }

  function checkWishlistStatus(data) {
    if ($('.customer-logged-in').length > 0) {
      $(".wishlist_collections").each(function () {
        var $this = $(this);
        var variantId = $this.attr("variantid");

        if (data.some(item => item.d2c_id === variantId)) {
            $this.addClass("btn-active");
            $this.find(".tooltip").text(window.languages.removeWishlistText);
          }
        });
    }
  }

  function getWishlist() {
    if ($('.customer-logged-in').length > 0) {
      var varid = [],
        wishlist_content = $(".wishlist-content"),
        wishlist__count = $(".wishlist__count");

      var locale = window.theme.locale === 'en' ? '' : '/'.concat(window.theme.locale);

      callAPIWithGWXToken('favorite/sso_get', 'GET')
        .then((res) => {
          var data = res.data;

          checkWishlistStatus(data);

          var handle_arr = [];

          if (data != null) {
            for (let i = 0; i < data.length; i++) {
              var variantId = data[i].d2c_id;
              var productHandle = data[i].handle;

              if (!productHandle) {
                continue;
              }
  
              varid.push(variantId);

              if (jQuery.inArray(productHandle, handle_arr) == -1) {
                handle_arr.push(productHandle);

                var wishlistProductPage = $(".template-product .product__details .wishlist_collections").attr("product-handle");

                if (wishlistProductPage == productHandle) {
                  $(".template-product .input_variants").attr("data_variants", variantId.toString());
                }

                if (productHandle != null && wishlist_content.length > 0) {

                  $.get(locale + '/products/' + productHandle + '?view=wishlist', function (data) {
                    wishlist_content.append(data).html();
                  }).then(function (data) {
                    for (let k = 0; k < varid.length; k++) {
                      var n = varid[k].toString();

                      // remove duplicated 
                      $('[data-variant="' + n + '"]:not(:first)').remove();

                      $(".wishlist-page .grid__cell").each(function () {
                        var $this = $(this);
                        var g = $this.attr("data-variant").toString();

                        if (n === g) {
                          $this.show();
                          $this.addClass("adding_wishlist");
                        }
                      });
                      }

                    $(".wishlist-content > .grid__cell:not(.adding_wishlist)").remove();
                  });
                }
              }
            }
          }

          var count = varid.length;
          wishlist__count.text(count);
        });

      if ($('.template-product').length > 0) {
        $(".template-product .product__details .wishlist_collections").click(function () {
          var s = $(this).attr("variantid");
          var d = $(".product__details .input_variants").attr("data_variants");
          var wishlistarrays = d.split(",");

          if ($.inArray($(this).attr("variantid"), wishlistarrays) !== -1) {
            d = d.replace(s + ",", "").replace("," + s, "").replace(s, "");
            $(".product__details .input_variants").attr("data_variants", d);
          }
          else {
            if (d != "") {
              $(".product__details .input_variants").attr("data_variants", d + "," + s);
            }
            else {
              $(".product__details .input_variants").attr("data_variants", s);
            }
          }
        });

        var selected = $("#sony-new-variant").val();
        $(".template-product .product__details .wishlist_collections").attr('variantid', selected);
      }
    }
  }

  loginWishlist();
  addWishlist();
  removeWishlist();
  getWishlist();
  
  function checkoutlink(){
    const localeValue = document.documentElement.lang;
    $(document).on('click', '.mini-cart__buttons .checkout_link, .checkout_link', function(e){
      $.cookie('check_out', "checkout",{expires:1, path:'/'});
      sessionStorage.localeCheckout = localeValue;
    });

    if( $.cookie('check_out') != undefined && $('.check__out').length){
      const previousLocaleCheckout = sessionStorage.getItem("localeCheckout");
      $('body.template-customers-account').hide();
      if (previousLocaleCheckout === 'th') {
        window.location.href= "/th/cart";
      } else {
        window.location.href= "/cart";
      }
      $.cookie('check_out', "checkout",{expires:-1, path:'/'});
    } else {
      $('body.template-customers-account').show();
      if ($('.check__out').length){
        $('head title').text($("#sony-title-page").text());
      }
    }
  }
  
  // SESD 1088
  function checkLoginTH(){
    const loginButton = $(".nav-dropdown__link--signin, .page__action-button .button-logout, .link--logout-mb");
    const localeValue = document.documentElement.lang;
    
    loginButton.on('click', function() {
      sessionStorage.locale = localeValue;
    })
    
    const urlCart = window.location.pathname;
    const previousLocale = sessionStorage.getItem("locale")
    if (previousLocale === 'th') {
      if (urlCart.indexOf("/account") == 0) {
        window.location.href = '/th/account';
        sessionStorage.locale = '';
      }
    } 
  }
  
  // SESD 1088
  function checkLogoutTH(){
    const logoutButton = $(".nav-dropdown__link--signout");
    const localeValue = document.documentElement.lang;
    
    logoutButton.on('click', function() {
      sessionStorage.locale = localeValue;
    })
    
    const urlCart = window.location.pathname;
    const previousLocale = sessionStorage.getItem("locale")
    if (previousLocale === 'th') {
      if (urlCart.indexOf("/th") == 0) {
        window.location.href = '';
        sessionStorage.locale = '';
      } else {
        window.location.href = '/th';
        sessionStorage.locale = '';
      }
    } 
  }

  if ($("body").hasClass("trademark--v3")) {
    checkoutlink();
    checkLoginTH();
    checkLogoutTH()

    var locations = window.location.href;
    if(locations != ""){
      var url_data = locations.split("?");
      if(url_data.length > 1){
        var temp = "";
        for (let i=0; i<url_data.length; i++ ){
       		var temp2 = url_data[i];
          if (temp2 == "locale=th" || temp2 == "locale=en" ){
            var temp =  url_data[i];
          	break;
          }else{
          	 var temp =  url_data[1];
          }
        }
        if(temp != ""){
          var temp1 = temp.split("&");
          if(temp1.length > 0 ){
            for (let j=0; j<temp1.length; j++ ){
            	var temp3 = temp1[j];
              if (temp3 == "locale=th" || temp3 == "locale=en" ){
              	locale = temp1[j];
              } else{
              	locale = temp1[0];
              }
            }
          }
        }
      }
    };

    /**Redirect in collection and product detail**/

    //custom product detail
    $( ".product-features .block-3column" ).each(function() {
        var block_3column_wrapper = $(this).html();
      $(this).html("<div>" + block_3column_wrapper + "</div>");
      });

  }

  if ($("body").hasClass("template-customers-order")) {
    /**order detail**/
    var shipping_label = $(".order__items .shipping-method").attr("data-label");

    if(shipping_label != "" && shipping_label.search ("Standard shipping") != -1){
      var shipping_label_new = shipping_label.replace("Standard shipping", window.languages.standard_shipping);
      $(".order__items .shipping-method").attr("data-label",shipping_label_new);
    }
  }

  /**Validate form edit**/
  if ($("body").hasClass("trademark--v3")) {
    $(".edit-profile-btn").click(function () {

      $('.form-edit-validate').validate({
        rules: {
          'customer[first_name]': {
            required: true,
            maxlength: 50
          },

          'customer[last_name]': {
            required: true,
            maxlength: 50
          },

          'customer[email]': {
            required: true,
            maxlength: 50
          },
          'customer[phone]': {
            required: true,
            maxlength: 15
          }
        },

        submitHandler: function(form) {
          var email = $('input[name="customer[email]"]').val();
          var datakey = $("#customer-id").val();
          var postData = {
            "origin": "TH",
            "country_locale": "th_TH",
            "first_name": $("#customer-firstname").val(),
            "last_name": $("#customer-lastname").val(),
            "phone": $("#customer-phone").val(),
            "email": $("#customer-email").val()
          }

          var btnSignUp = $('.edit-profile-btn');
          btnSignUp.addClass('button--loading');
          btnSignUp.prop('disabled', true);

        callAPIWithTokenRefresh('customers', 'post', postData, datakey)
          .then(function(res){
            if (res.status) {
              $('.alert').removeClass("alert--error");
              $('.alert').addClass("alert--success");
              $('.alert__title').text(window.languages.editProfileSuccess);
            }
            else {
              $('.alert').removeClass("alert--success");
              $('.alert').addClass("alert--error");
              if(res.message == "Invalid phone number."){
                $('.alert__title').text(window.languages.edit_phone_invalid);
              }
              else{
                $('.alert__title').text(window.languages.edit_phone_existed);
              }

            }
          })
          .finally(function(e){
            btnSignUp.removeClass('button--loading');
            btnSignUp.prop('disabled', false);
          });

        }
      });


    });

    $(".find_store__form [type='submit']").click(function () {

      $('.find_store__form').validate({
        rules: {
          '#find-store-postcode': {
            required: true
          }
        },

        submitHandler: function(form) {
          var postcode = $('#find-store-postcode').val();
          var url = $(".find_store__form").attr("action");
          url = url + "/?query=" + postcode;
          window.open(url, '_blank');
          return false;
        }
      });


    });

    $("#btnChangePassword").click(function () {
      $('.form-validate').validate({
        rules: {
          'email': {
            required: true,
            email: true
          },

          'current_password': {
            required: true,
            rangelength: [8, 20]
          },

          'new_password': {
            required: true,
            rangelength: [8, 20],
            pwcheck: "Password Valid!"
          }
        },

        submitHandler: function(form) {
          var postData = {
            "id": $('#change-password input[name="customer_id"]').val(),
            "current_password": $('#change-password input[name="current_password"]').val(),
            "password": $('#change-password input[name="new_password"]').val()

          }
          var btnChangePassword = $("#btnChangePassword");
          btnChangePassword.addClass('button--loading');
          btnChangePassword.prop('disabled', true);

        callAPIWithTokenRefresh('customers/change_pwd', 'put', postData)
          .then(function(res){
            if (res.status) {
              res.message = window.languages.change_password_success;
              $('.reg--error').removeClass("alert--error");
              $('.reg--error').addClass("alert--success");
            }
            else {
              $('.reg--error').show();
              if(res.message == "Your password is incorrect.") {
                res.message = window.languages.change_password_wrong_pass;
              }
              else if(res.message == "No account found with that email.") {
                res.message = window.languages.change_password_wrong_email;
              }
              else if(res.message == "Password can not change.") {
                res.message = window.languages.change_password_fail;
              }

              $('.reg--error').removeClass("alert--success");
              $('.reg--error').addClass("alert--error");
            }

            $('.reg--error--title').text(res.message);
            $('.reg--error').show();
          })
          .finally(function(e){
            btnChangePassword.removeClass('button--loading');
            btnChangePassword.prop('disabled', false);
          });

          return false;
        }
      });

      $.validator.addMethod("pwcheck", function(value, element) {
        return /^[A-Za-z0-9\d=`~!@#$%^&*\(\)_\-+=\{\}\[\];:'"\\|<>,.?\/]*$/.test(value) // consists of only these
        && /[a-z]/.test(value) // has a lowercase letter
        && /[A-Z]/.test(value) // has a uppercase letter
        && /\d/.test(value) // has a digit
        && /[`~!@#$%^&*\(\)_\-+=\{\}\[\];:'"\\|<>,.?\/]/.test(value) //has one special character without space
      }, window.languages.invalid_password);



    });

    $("#money_vat").text(Shopify.formatMoney($("#money_vat").text(), window.theme.order_money));
  $("#excluded_tax").text(Shopify.formatMoney($("#excluded_tax").text(), window.theme.order_money));

  }

  /**Multi language**/

  $( ".multi-language-selector >span" )
  .mouseover(function() {
    $(this).parent().addClass("open");
  })
  .mouseout(function() {
    $(this).parent().removeClass("open");
  });

  $( ".multi-language-selector .localization-form" )
  .mouseover(function() {
    $(this).parent().addClass("open");
  })
  .mouseout(function() {
    $(this).parent().removeClass("open");
  });

  


  /***Delete Address***/
  $(".delete-address").click(function(){
    if (confirm(window.languages.delete_confirm)) {
      // your deletion code
      var address_id = $(this).attr("data-address-id");

      Shopify.postLink('/account/addresses/'+ address_id, {'parameters': {'_method': 'delete'}});
    }
    else{
      event.preventDefault();
    }

    return false;
  });

  function showReview(){
    if($(window).innerWidth() > 800){
      if (!$('.product-review-m').is(':empty')){
        //do something
        var html = $(".product-review-m").html();
        $(".product-review").html(html);
      }
    }
    else {
      if (!$('.product-review').is(':empty')){
        var html = $(".product-review").html();
        $(".product-review-m").html(html);

      }
    }



  }

  /**Show review tab after clicking star**/


  window.bvCallback = function(BV) {
    if (!BV) return;

   BV.reviews.on('show', function() {
     if($(window).innerWidth() > 800){
       $('.tabs__nav-item.review-tab-title').click();

       setTimeout(function(){
         $('html, body').animate({
           scrollTop: $(".product__tabs.gwt__tab--active").offset().top - 100
         }, 0);

       }, 100);

     }
     else {
       if(!$(".gwt__tab-m--active .tabs__nav-item-m > .review-tab-title").hasClass("active")){
         $('.gwt__tab-m--active .tabs-title.review-tab-title').click();
       }

       setTimeout(function(){
         $('html, body').animate({
           scrollTop: $(".gwt__tab-m--active .tabs-title.review-tab-title").offset().top - 50
         }, 0);

       }, 100);

     }

       return false;

   });

};


  /**Hide no review***/
  function hideNoRating(){
    $(".product-item").each(function(){

      var inline_rating = $(this).find('[data-bv-show="inline_rating"]');
      var bv_text = $(this).find('.bv_text').text();

      if(bv_text == '(0)'){
        inline_rating.hide();
      }

    });

    if($("#num-reviews-button").length && $("#num-reviews-button").text() == '(0)') {
         $('[data-bv-show="rating_summary"]').hide();
      $(".review-tab-title").hide();
      $(".review-tab-m").parents(".tabs__nav-item-m").hide();
    }
  }

  function moveReviewToTabs(){
    var reviewHtml = '';

    if($(".product-review-container").length && reviewHtml == ""){
      reviewHtml = $(".product-review-container").html();
      $(".product-review-container").remove();
    }
    else if($(window).innerWidth() > 800 && reviewHtml == "") {
      reviewHtml = $(".tabs__content-item.review-tab .product-review #BVRRSearchContainer").parents(".product-review").html();
    }
    else if($(window).innerWidth() <= 800 && reviewHtml == "") {
      reviewHtml = $(".tabs__content-item-m .review-tab-m .product-review-m #BVRRSearchContainer").parents(".product-review-m").html();
    }
    
    if($(window).innerWidth() > 800){
      $(".product-review-m").html("");
      
      $(".product__tabs").each(function(){
        if($(this).hasClass("gwt__tab--active")){
          //move review
          $(this).find(".tabs__content-item.review-tab .product-review").html(reviewHtml);
        }
        else {
          $(this).find(".tabs__content-item.review-tab .product-review").html("");
        }
      });
    }
    else {
      $(".product-review").html("");
      $(".product__tabs-m").each(function(){
        if($(this).hasClass("gwt__tab-m--active")){
          //move review
          $(this).find(".tabs__content-item-m .review-tab-m .product-review-m").html(reviewHtml);
        }
        else {
          $(this).find(".tabs__content-item-m .review-tab-m .product-review-m").html("");
        }
      });   
    };
  }

  var variantSelector = $(".product__form .single-option-selector");

  variantSelector.on("change", function() {
    $(".tabs__nav-item").removeClass("tabs__nav-item--active");
    $(".tabs__content-item").removeClass("tabs__content-item--active");
    $(".tabs-title.review-tab-title").removeClass("active");

    setTimeout(function(){
      $(".product__tabs.gwt__tab--active").find(".tabs__nav-item:first-child").addClass("tabs__nav-item--active");
      $(".product__tabs.gwt__tab--active").find(".tabs__content-item:first-child").addClass("tabs__content-item--active");
      $(".product__tabs-m.gwt__tab-m--active").find(".tabs__nav-item-m:first-child .tabs-title").addClass("active");
      $(".product__tabs-m.gwt__tab-m--active").find(".tabs__nav-item-m:first-child .tabs-title + ul").show();
      moveReviewToTabs();
    }, 800);
  });

  // Social Account Page
  if ($('.social-account-page')[0]) {
    getSocialAccounts();
    checkStatusUnlink();
  }

  function getSocialAccounts(){
    let customer_id = $('.header__secondary-nav .wishlist a').attr('data-customer_id');
    callAPIWithTokenRefresh(`customers/get_social_by_ShopifyCustomer?customerID=${customer_id}`, 'get')
      .then(function(res) {
        if (res.length > 0) {
          res.forEach((element, index) => {
            appendDataSocialList(element, index);
            // console.log(element.socialId);

            let buttonUnlink = $(`.social-account-listing__item .button[data-index="button-index-${index}"]`);
            let idpLogin = $('#idp-login').val();
            let messageConfirmDelete;
            if (idpLogin == 'google.com') {
              messageConfirmDelete = `${$('#message-unlink').val()} GOOGLE`;
            } else if (idpLogin == 'facebook.com') {
              messageConfirmDelete = `${$('#message-unlink').val()} FACEBOOK`;
            } else if (idpLogin == 'https://access.line.me') {
              messageConfirmDelete = `${$('#message-unlink').val()} LINE`;
            }

            // let messageUnlinkSuccess = $('#message-unlink-success').val();
            buttonUnlink.on('click', function() {
              if (confirm(messageConfirmDelete)) {
                window.location.href= "https://stg.login.sony-asia.com/f3579197-f659-4e21-9ab7-81c873b202e9/oauth2/v2.0/authorize?p=B2C_1_eComTH_STG_su_si&client_id=96fcf84d-abdb-4dff-93fa-b59a99659fbe&nonce=defaultNonce&redirect_uri=https://stg.hub.sony-asia.com/api/stores/7257489519/customers/socialunlink&scope=openid&response_type=code&response_mode=query&ui_locales=en";
                // this.parentNode.remove();
                $('.social-account-loading').removeClass('hide');
              }
            })
          });
        } else {
          let messageAccountEmpty = $('#message-account-empty').val();
          // console.log('no result');
          $('.social-account-listing').append(`
            <li class="social-account-listing__item social-account-listing__item--sms">
              <p class="sms-empty">${messageAccountEmpty}</p>
            </li>`
          );
        }
      })
  };

  function appendDataSocialList(social, index) {
    let socialAccountListing = $('.social-account-listing');
    let idpLogin = $('#idp-login').val();
    // socialAccountListing.empty();
    let itemGoogle = `
      <li class="social-account-listing__item social-account-listing__item--gg">
        <span class="account-button account-button--gg">Google</span>
        ${
          idpLogin == 'google.com' ? `<button class="button button--blue" data-index="button-index-${index}">Unlink</button>` : `<button class="button button--blue disabled" data-index="button-index-${index}">Unlink</button>`
        }
      </li>
    `;
    let itemFacebook = `
      <li class="social-account-listing__item social-account-listing__item--fb">
        <span class="account-button account-button--fb">Facebook</span>
        ${
          idpLogin == 'facebook.com' ? `<button class="button button--blue" data-index="button-index-${index}">Unlink</button>` : `<button class="button button--blue disabled" data-index="button-index-${index}">Unlink</button>`
        }
      </li>
    `;
    let itemLine = `
      <li class="social-account-listing__item  social-account-listing__item--line">
        <span class="account-button account-button--line">Line</span>
        ${
          idpLogin == 'https://access.line.me' ? `<button class="button button--blue" data-index="button-index-${index}">Unlink</button>` : `<button class="button button--blue disabled" data-index="button-index-${index}">Unlink</button>`
        }
      </li>
    `;
    if (social.socialPlatform == 0) {
      socialAccountListing.append(itemGoogle);
    } else if (social.socialPlatform == 1) {
      socialAccountListing.append(itemFacebook);
    } else if (social.socialPlatform == 2) {
      socialAccountListing.append(itemLine);
    }
  }

  function checkStatusUnlink(){
    let messageUnlinkError = $('#message-unlink-error').val();
    let pageUrl = window.location.search.substring(1);
    let urlVariable = pageUrl.split('&');
    let urlInfo = {};
    let idpLogin = $('#idp-login').val();
    let messageUnlinkSuccess;
    if (idpLogin == 'google.com') {
      messageUnlinkSuccess = `${$('#message-unlink-success').val()} GOOGLE`;
    } else if (idpLogin == 'facebook.com') {
      messageUnlinkSuccess = `${$('#message-unlink-success').val()} FACEBOOK`;
    } else if (idpLogin == 'https://access.line.me') {
      messageUnlinkSuccess = `${$('#message-unlink-success').val()} LINE`;
    }

    for (let entry of urlVariable) {
      let pair = entry.split("=");
      urlInfo[pair[0]] = pair[1];
    }

    if (pageUrl) {
      if (urlInfo.UnlinkResult == 'True') {
        $('.social-account-listing').append(`
          <li class="social-account-listing__item social-account-listing__item--sms">
            <p class="sms-success">${messageUnlinkSuccess}</p>
          </li>`
        );
      } else if (urlInfo.UnlinkResult == 'False') {
        $('.social-account-listing').append(`
          <li class="social-account-listing__item social-account-listing__item--sms">
            <p class="sms-error">${messageUnlinkError}</p>
          </li>`
        );
      }
      $('.social-account-loading').addClass('hide');
      window.history.pushState("", "", window.location.pathname);
    }
  };
  
  // End Social Account Page

  /**
   * Logout user after a certain period of inactivity
   */
  $(function() {
    const isLoggedIn = window.theme.isLoggedIn;

    if (isLoggedIn) {
      console.log('handle user in activity');
      handleInactivity();
    }
  });
  
  function handleInactivity() {
    let idleTime = 0; // Timer to track idle time in minutes
    let maxIdleTime = "2000" || 20; // Maximum idle time in minutes (adjust as needed)

    console.log('user idle time', maxIdleTime);
    // Function to reset idle time
    function resetIdleTime() {
      idleTime = 0;
    }

    // Function to log out the user
    function logoutUser() {
      console.log('logout due to inactivity after idle time');
      const tokenHintMetafield = window.theme.customerTokenHintMetafield;

      // Redirect to logout URL
      window.location.href = tokenHintMetafield !== '' 
                            ? `https://stg.login.sony-asia.com/f3579197-f659-4e21-9ab7-81c873b202e9/oauth2/v2.0/logout?p=B2C_1_eComTH_STG_su_si&redirect_uri=https%3A%2F%2Fstg.hub.sony-asia.com%2Fapi%2Fstores%2F7257489519%2Fcustomers%2Fsign_out&id_token_hint=${tokenHintMetafield}`
                            : `${window.theme.locale === 'th' ? '/th/account/logout' : '/account/logout'}`;

    }

    // Reset idle time on any user activity
    document.onmousemove = resetIdleTime;
    document.onkeydown = resetIdleTime;
    document.onclick = resetIdleTime;
    document.onscroll = resetIdleTime;
   
    // Check idle time at regular intervals (every minute)
    const intervalId = setInterval(function () {
      idleTime++;

      if (idleTime >= maxIdleTime) {
        clearInterval(intervalId);
        logoutUser(); // Log out if idle time exceeds maxIdleTime
      }
    }, 60000); // Check every 60 seconds (1 minute)
  }
}(jQuery));


